<template>
  <button @click="$emit('mais')">{{sinal}}</button>
</template>

<script>
export default {
  props: ['sinal']
}
</script>

<style>
    button {
      background-color: #C2171A;
      color: #FFEC00;
      border: none;
      border-radius: 50px;
      -webkit-border-radius: 50px;
      -moz-border-radius: 50px;
      width: 2rem;
      height: 2rem;
      position: relative;
      margin: 0.5rem;
      font-size: 1.3rem;
      align-items: center;

      transition-duration: 0.4s;
      text-decoration: none;
      overflow: hidden;
      cursor: pointer;
    }

    button:hover {
      background-color: #C2171A;
      color: #ffffff;
      border: none;
      border-radius: 50px;
      -webkit-border-radius: 50px;
      -moz-border-radius: 50px;
      width: 2rem;
      height: 2rem;
      position: relative;
      margin: 0.5rem;
      font-size: 1.5rem;
    }

    button:after {
      content: "";
      background:#ffffff;
      display: block;
      position: absolute;
      padding-top: 300%;
      padding-left: 350%;
      margin-left: -20px!important;
      margin-top: -120%;
      opacity: 0;
      transition: all 0.8s
    }

    button:active:after {
      padding: 0;
      margin: 0;
      opacity: 1;
      transition: 0s
    }
</style>
